import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';
import { AbbreviatedNumber } from '../../../common/number';
import Text from '../../../common/text';
import { NO_DATA } from '../../../../constants';

function AssetItemDataText(props) {
  const { value } = props;

  if (value === null || value === undefined) {
    return <Text>{NO_DATA}</Text>
  }


  if (typeof value !== 'number') {
    return null;
  }
  return (
    <AbbreviatedNumber
      renderProps={{ size: 'large' }}
      renderExactAs="currency"
      maxDigits={8}
      value={value}
    />
  );
}

AssetItemDataText.propTypes = {
  value: PropTypes.number,
};

export default pure(AssetItemDataText);
